/* eslint-disable import/no-import-module-exports */
import { configureStore, isImmutableDefault } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { isImmutable } from 'immutable';
import createSagaMiddleware from 'redux-saga';

import { navigationMiddleware } from 'middleware/navigationMiddleware';
import createReducer from 'reducers';
// Import all API files to ensure endpoints are injected
import 'redux/api/apiKeyGenerator.api';
import 'redux/api/authorization.api';
import 'redux/api/companies.api';
import 'redux/api/dashboard.api';
import 'redux/api/documents.api';
import 'redux/api/fileUpload.api';
import 'redux/api/forms.api';
import 'redux/api/formsLibraryService.api';
import 'redux/api/genericInfiniteQuery.api';
import 'redux/api/groups.api';
import 'redux/api/kolimmo.api';
import 'redux/api/mediaService.api';
import 'redux/api/meetings.api';
import 'redux/api/modules.api';
import 'redux/api/observations.api';
import 'redux/api/organizationMembers.api';
import 'redux/api/phases.api';
import 'redux/api/plans.api';
import 'redux/api/priorities.api';
import 'redux/api/projectMembers.api';
import 'redux/api/projects.api';
import 'redux/api/registration.api';
import 'redux/api/statuses.api';
import 'redux/api/superAdminOrganizations.api';
import 'redux/api/user.api';
import 'redux/api/userInfos.api';
import 'redux/api/workspaceMembers.api';
import 'redux/api/workspaces.api';
import { api } from 'redux/api/index.api';
import usersSlice from 'redux/slice/users.slice';
import history from 'utils/history';

export default function configureStoreFC() {
  const sagaMiddleware = createSagaMiddleware({});

  const store = configureStore({
    reducer: createReducer({
      router: connectRouter(history),
    }),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: {
          isImmutable: value => isImmutable(value) || isImmutableDefault(value),
        },
      }).concat(sagaMiddleware, routerMiddleware(history), navigationMiddleware, api.middleware),
  });
  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  store.injectedReducers.api = api.reducer;
  store.injectedReducers.usersSlice = usersSlice;

  // HMR indispensable pour ne pas perdre l'état Redux en dev lors de la modification d'un reducer
  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  return store;
}
